/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Table, Row, Col, message, Input, DatePicker, Button } from "antd";

import { camelCase, serialNum, getStartAndEndDate } from "../../../utils";
import urls from "../../../api/urls";
import API from "../../../api";
import { ReactComponent as Audit_icon } from "../../../assests/images/middleMile/audited-icon.svg";
import search_icon from "../../../assests/images/search-icon.svg";

import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { ReactComponent as Substract } from "../../../assests/images/subtract.svg";
import { ReactComponent as Aubstract } from "../../../assests/images/aubtract.svg";
import download_pin_icon from "../../../assests/images/SVG/download-pin.svg";

import constants from "../../../constants/constants";
import moment from "moment";
const {
  AUDIT_LIST,
  AUDIT_EXCEL_DOWNLOAD,
} = urls;
const { RangePicker } = DatePicker;

const NewAudit = ({ activeKey }) => {
  const [manifestedCp, setManifestedCp] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pageNum, setPageNum] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [pageSize, setPageSize] = useState(10);

  const [startAndEndDate, setStartAndEndDate] = useState({});
  const [serachValue, setSerachValue] = useState(null);

  const { ROLES } = constants;
  const { HO_ADMIN, HUB_ADMIN } = ROLES;

  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const userId = JSON.parse(localStorage.getItem("userId"));

  const isWeightAudit = (record) =>
    (record?.auditType || "").toString().toUpperCase() === "WEIGHT";

  const displayValue = (value) =>
    value !== null && value !== undefined && value !== "" ? value : "-----";

  const renderAuditValue = (record, valueType) => {
    if (isWeightAudit(record)) {
      return (
        <TableCompo
          actual={valueType === "booked" ? record?.bookedWeight : record?.auditedWeight}
          l={valueType === "booked" ? record?.bookedLength : record?.auditedLength}
          b={valueType === "booked" ? record?.bookedWidth : record?.auditedWidth}
          h={valueType === "booked" ? record?.bookedHeight : record?.auditedHeight}
          volumetric={valueType === "booked" ? record?.volumetricBookedValue : record?.volumetricAuditedValue}
        />
      );
    }

    return (
      <FieldAuditValue
        fieldName={record?.fieldName}
        value={valueType === "booked" ? record?.bookedValue : record?.auditedValue}
      />
    );
  };

  const getRole = userinfo?.roles[0];

  useEffect(() => {
    const todaysDate = moment().format("DD-MM-YYYY");
    const yesterday = moment().subtract(1, "days").format("DD-MM-YYYY");
    setStartAndEndDate({ start: yesterday, end: todaysDate });
    getManifest(`?pageNo=0&pageSize=${pageSize}`, yesterday, todaysDate, null);
  }, []);

  useEffect(() => {
    if (serachValue === null) {
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      setCurrentPage(1);
      setPageNum(1);
      getManifest(
        `?pageNo=0&pageSize=${pageSize}`,
        startAndEndDate?.start,
        startAndEndDate?.end,
        serachValue
      );
    }, 900);
    return () => clearTimeout(delayDebounceFn);
  }, [serachValue]);

  const downloadURL = () => {
    const baseUrl = AUDIT_EXCEL_DOWNLOAD;
    const dateParams = getStartAndEndDate(
      startAndEndDate?.start,
      startAndEndDate?.end,
      "DD-MM-YYYY"
    );

    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }

    // Use active hub ID if available, otherwise fallback to user's premise ID
    const effectivePremiseId = activeHub?.hubId || userId?.userInfo?.premiseId;
    const premiseIdParam = `&SMCS-PREMISE-ID=${effectivePremiseId}`;
    const searchParam =
      serachValue && serachValue.trim().length > 0
        ? `&search=${encodeURIComponent(serachValue.trim())}`
        : "";

    return `${baseUrl}?pageNo=${pageNum - 1
      }&pageSize=${pageSize}${dateParams}${premiseIdParam}${searchParam}`;
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",

      render: (a, b, idx) => serialNum(10, pageNum, idx),
      dataIndex: "slno",
      key: "slno",
      width: 80,
    },
    {
      title: "Awb No",
      dataIndex: "awbNumber",
      key: "awbNumber",

      render: (text, val) => {
        return (
          <div>
            <span style={{ marginRight: "10px" }}>{text}</span>
            {val.auditStatus && <Audit_icon />}
          </div>
        );
      },
    },
    {
      title: "Source Hub",
      dataIndex: "sourceHubName",
      key: "sourceHubName",
      sorter: (a, b) => a.sourceHubName.localeCompare(b.sourceHubName),
      render: (text) => {
        return text ? camelCase(text) : "-----";
      },
    },
    {
      title: "Destination Hub",
      dataIndex: "destinationHubName",
      key: "destinationHubName",
      sorter: (a, b) =>
        a.destinationHubName.localeCompare(b.destinationHubName),

      render: (text) => {
        return text ? camelCase(text) : "-----";
      },
    },
    {
      title: "Audited Hub Details",
      dataIndex: "auditedHub",
      key: "auditedHub",
      render: (text, rec) => {
        return (
          <>
            <div>{text && camelCase(text)}</div>
            <div>{rec?.auditTime && rec?.auditTime}</div>
          </>
        );
      },
    },
    {
      title: "Booking types",
      dataIndex: "bookingType",
      key: "bookingType",

      render: (text) => {
        return text ? text : "-----";
      },
      width: 120,
    },
    {
      title: "Service type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (text) => {
        return text ? text : "-----";
      },
      width: 120,
    },
    {
      title: "No of Audit Parameter",
      dataIndex: "noOfAuditParam",
      key: "noOfAuditParam",
      render: (text) => {
        return text ? text : "-----";
      },
    },
    {
      title: "Audited for",
      dataIndex: "auditType",
      key: "auditType",

      render: (text) => (text ? camelCase(text) : "-----"),
    },
    {
      title: "Booking Value",
      dataIndex: "auditType",
      key: "premiseName",

      render: (text, rec) => renderAuditValue(rec, "booked"),
      width: 250,
    },
    {
      title: "Audited Value",
      dataIndex: "auditType",
      key: "premiseName",
      render: (text, rec) => renderAuditValue(rec, "audited"),
      width: 250,
    },
    {
      title: "Alert type",
      dataIndex: "volWeightDiffPerc",
      key: "volWeightDiffPerc",
      fixed: "right",

      render: (recored, rec) => {
        if (!isWeightAudit(rec)) {
          return "-----";
        }
        const shouldRenderSubstract =
          (rec?.weightDiffPerc && rec?.weightDiffPerc > 10) ||
          (rec?.volWeightDiffPerc && rec?.volWeightDiffPerc > 10);

        return shouldRenderSubstract ? <Aubstract /> : <Substract />;
      },
    },
  ];

  const getManifest = async (page, start, end, search) => {
    setLoading(true);
    const searchParam =
      search && search.trim().length > 0
        ? `&search=${encodeURIComponent(search.trim())}`
        : "";
    let response = await API.Api(
      AUDIT_LIST +
      `premise${page}` +
      getStartAndEndDate(start, end, "DD-MM-YYYY") +
      searchParam
    ).getWithPremiseHeader();
    if (response.status) {
      setLoading(false);
      let temp = [];
      response?.response?.data?.auditReports?.forEach((e, index) => {
        temp.push({ ...e, slno: index + 1 });
      });
      setTotalPageSize(response?.response?.data?.count);
      setManifestedCp(temp);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Something went wrong"
      );
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  function handlePageChange(pagination) {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);

    getManifest(
      `?pageNo=${pagination.current - 1}&pageSize=${pagination.pageSize}`,
      startAndEndDate?.start,
      startAndEndDate?.end,
      serachValue
    );
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleOnclick = () => {
    setCurrentPage(1);
    setPageNum(1);
    getManifest(
      `?pageNo=0&pageSize=${pageSize}`,
      startAndEndDate?.start,
      startAndEndDate?.end,
      serachValue
    );
  };

  const TableCompo = ({ l, b, h, volumetric, actual }) => {
    return (
      <Row justify={"space-between"} gutter={[10, 15]} style={{ width: "500" }}>
        <Col lg={16} style={{ fontWeight: "500" }}>
          Actual
        </Col>
        <Col lg={8}>{displayValue(actual)}</Col>
        <Col lg={16} style={{ fontWeight: "500" }}>
          Volumetric
        </Col>
        <Col lg={8}>{displayValue(volumetric)}</Col>
        <Col lg={16} style={{ fontWeight: "500" }}>
          LWH
        </Col>
        <Col lg={8}>{`${displayValue(l)},${displayValue(b)},${displayValue(h)}`}</Col>
      </Row>
    );
  };

  const FieldAuditValue = ({ fieldName, value }) => {
    return (
      <Row justify={"space-between"} gutter={[10, 15]} style={{ width: "500" }}>
        <Col lg={16} style={{ fontWeight: "500" }}>
          {fieldName ? camelCase(fieldName) : "Value"}
        </Col>
        <Col lg={8}>{displayValue(value)}</Col>
      </Row>
    );
  };

  const [dateRangeStatus, setDateRangeStatus] = useState(false);

  const handleDateChange = (prarms, p2) => {
    const StartDate = moment(p2[0], "DD/MM/YYYY").format("DD-MM-YYYY");
    const endDate = moment(p2[1], "DD/MM/YYYY").format("DD-MM-YYYY");
    setStartAndEndDate({ start: StartDate, end: endDate });
    if (p2[0]?.length === 0) {
      // getTableData();
      setDateRangeStatus(false);
    } else {
      setDateRangeStatus(true);
    }
  };

  const handleInputChange = (e) => {
    setSerachValue(e.target.value);
  };

  return (
    <>
      <div className="consolidated-manifest-cntr m-1">
        <div className="new-header ml-1">
          <Row gutter={12} justify={"space-between"}>
            <Col className="center" span={8}>
              <Input
                placeholder="Search AWB number,Source HUB name"
                bordered
                style={{
                  borderRadius: "5px",
                  height: "40px",
                  width: "100%",
                }}
                suffix={<img src={search_icon} />}
                onChange={handleInputChange}
              />
            </Col>
            <Col className="d-flex" alignContent={""}>
              <RangePicker
                onChange={handleDateChange}
                format={"DD/MM/YYYY"}
                disabledDate={(current) => disabledDate(current)}
                defaultValue={[moment().subtract(1, "days"), moment()]}
                style={{
                  borderRadius: "5px 0 0 5px",
                  height: "40px",
                  width: "230px",
                }}
              />
              <Button
                className="center mr-1"
                disabled={!dateRangeStatus}
                style={{
                  width: "40px",
                  height: "40px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "0 5px 5px 0",
                }}
                onClick={handleOnclick}
              >
                <img src={search_icon} />
              </Button>
              <Button
                className="cancel-btn ml-1"
                style={{ height: "auto" }}
                onClick={() => window.open(downloadURL())}
              >
                <img src={download_pin_icon} alt="download logo" />
                &nbsp; DOWNLOAD REPORT
              </Button>
            </Col>
          </Row>
        </div>

        <Table
          columns={columns}
          dataSource={manifestedCp}
          scroll={{
            x: 2000,
            y: 500,
          }}
          onChange={handlePageChange}
          // pagination={{
          //   current: currentPage,
          //   pageSize: total,
          //   total: pageSize ,
          //   itemRender: itemRender,
          // }}

          pagination={{
            // pageSize: pageSize,
            // total: inputSearchValue.length == 0 ? tableData.length : 10,
            pageSizeOptions: ["10", "50", "100", "500", "1000"],
            current: currentPage,
            pageSize: pageSize,
            total: totalPageSize,
            // total: 100,
            itemRender: itemRender,
          }}
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
        />
      </div>
    </>
  );
};

export default NewAudit;
